import withRouter from './withRouter';
export default withRouter;
